module.exports = __webpack_public_path__ + "img/loading.4a6c28e1.svg";